import type { StripeCreateInvoiceResponse } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { USE_INVOICES_OVERVIEWS_QUERY_KEY } from './use-invoices-overviews/use-invoices-overviews-consts';

type mutationInputType = { 
  invoiceIds: string[] 
};

export function useSyncToStripe(options?: UseMutationOptions<StripeCreateInvoiceResponse, unknown, mutationInputType>) {
  const queryClient = useQueryClient();

  const mutationFn = (variables: mutationInputType) => {
    const api = getPrivateApi();

    return api.stripeCreateInvoice({
      stripeCreateInvoiceRequest: {
        invoicesIds: variables.invoiceIds,
      },
    });
  };

  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries([USE_INVOICES_OVERVIEWS_QUERY_KEY]);
    },
    ...options,
  });
}